// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminProctoringViolations_page__wXCVM { max-width: 1600px; }

.AdminProctoringViolations_header__1J-F6 {
  margin-bottom: 2rem;
}

.AdminProctoringViolations_title__bsAmN { font-size: 1.4rem; color: var(--black); margin-bottom: 0.2rem; font-weight: 700; }
.AdminProctoringViolations_subtitle__nFq-c { font-size: 0.8rem; color: var(--gray-500); }

.AdminProctoringViolations_loading__Fy1NV {
  padding: 2rem;
  text-align: center;
  color: var(--gray-500);
  font-size: 0.85rem;
}

.AdminProctoringViolations_emptyState__i2W09 {
  background: white;
  border: 2px dashed var(--border);
  border-radius: var(--radius-lg);
  padding: 3rem 2rem;
  text-align: center;
}

.AdminProctoringViolations_emptyIcon__JmPqg {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.AdminProctoringViolations_emptyTitle__aYiQV {
  font-size: 1.1rem;
  color: var(--gray-900);
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.AdminProctoringViolations_emptyText__CbZvD {
  font-size: 0.85rem;
  color: var(--gray-600);
}

/* Card List Layout */
.AdminProctoringViolations_cardsList__ckYN- {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
}

.AdminProctoringViolations_violationCard__a6mha {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: all 0.25s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.AdminProctoringViolations_violationCard__a6mha:hover {
  border-color: var(--gray-400);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.AdminProctoringViolations_cardHeader__6mLKy {
  padding: 0.5rem;
  border-bottom: 1px solid var(--gray-50);
  background: var(--gray-50);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.AdminProctoringViolations_candidateInfo__HMRt7 {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex: 1 1;
  min-width: 0;
}

.AdminProctoringViolations_candidateAvatar__yeo\\+t {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--green-light);
  color: var(--green);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.65rem;
  flex-shrink: 0;
}

.AdminProctoringViolations_candidateDetails__ayz7j {
  min-width: 0;
  flex: 1 1;
}

.AdminProctoringViolations_candidateName__hGfVG {
  font-weight: 600;
  color: var(--gray-900);
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.AdminProctoringViolations_candidateEmail__ICGZ- {
  font-size: 0.6rem;
  color: var(--gray-500);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.AdminProctoringViolations_statusBadge__3p79U {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 0.75rem;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
}

.AdminProctoringViolations_badgeIcon__POqcq {
  font-size: 0.8rem;
}

.AdminProctoringViolations_statusgreen__d-UTa {
  background: #d1fae5;
  color: #047857;
}

.AdminProctoringViolations_statusorange__Vq2Qu {
  background: #fed7aa;
  color: #b45309;
}

.AdminProctoringViolations_statusred__TESFR {
  background: #fee2e2;
  color: #dc2626;
}

.AdminProctoringViolations_statusdarkred__YlRAq {
  background: #fecaca;
  color: #7f1d1d;
}

/* Card Body */
.AdminProctoringViolations_cardBody__udtIs {
  padding: 0.5rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  flex: 1 1;
  border-bottom: 1px solid var(--gray-50);
}

.AdminProctoringViolations_metricItem__SxV\\+Z {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.AdminProctoringViolations_metricLabel__\\+lqCP {
  font-size: 0.6rem;
  text-transform: capitalize;
  letter-spacing: 0.04em;
  color: var(--gray-500);
  font-weight: 600;
}

.AdminProctoringViolations_metricValue__PRwJ0 {
  font-size: 0.7rem;
  color: var(--gray-900);
  font-weight: 500;
  line-height: 1.2;
}

.AdminProctoringViolations_metricValueHighlight__CvvE7 {
  font-size: 0.95rem;
  color: var(--red);
  font-weight: 700;
}

/* Card Footer */
.AdminProctoringViolations_cardFooter__F65ky {
  padding: 0.4rem 0.5rem;
  display: flex;
  justify-content: flex-end;
}

.AdminProctoringViolations_viewBtn__tATqc {
  padding: 0.35rem 0.6rem;
  background: var(--green);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.65rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.AdminProctoringViolations_viewBtn__tATqc:hover {
  background: var(--green-mid);
  transform: translateX(2px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .AdminProctoringViolations_cardsList__ckYN- {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  }
}

@media (max-width: 768px) {
  .AdminProctoringViolations_cardsList__ckYN- {
    grid-template-columns: 1fr;
  }

  .AdminProctoringViolations_cardBody__udtIs {
    grid-template-columns: 1fr 1fr;
    gap: 0.85rem;
  }

  .AdminProctoringViolations_metricItem__SxV\\+Z:nth-child(3) {
    grid-column: 1 / -1;
  }

  .AdminProctoringViolations_cardHeader__6mLKy {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .AdminProctoringViolations_statusBadge__3p79U {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .AdminProctoringViolations_cardsList__ckYN- {
    gap: 0.75rem;
  }

  .AdminProctoringViolations_cardHeader__6mLKy {
    padding: 0.85rem;
  }

  .AdminProctoringViolations_cardBody__udtIs {
    padding: 0.85rem;
  }

  .AdminProctoringViolations_cardFooter__F65ky {
    padding: 0.65rem 0.85rem;
  }

  .AdminProctoringViolations_candidateName__hGfVG {
    font-size: 0.85rem;
  }

  .AdminProctoringViolations_candidateEmail__ICGZ- {
    font-size: 0.7rem;
  }

  .AdminProctoringViolations_metricValue__PRwJ0 {
    font-size: 0.8rem;
  }

  .AdminProctoringViolations_metricValueHighlight__CvvE7 {
    font-size: 1rem;
  }

  .AdminProctoringViolations_viewBtn__tATqc {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminProctoringViolations.module.css"],"names":[],"mappings":"AAAA,yCAAQ,iBAAiB,EAAE;;AAE3B;EACE,mBAAmB;AACrB;;AAEA,0CAAS,iBAAiB,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AAC1F,6CAAY,iBAAiB,EAAE,sBAAsB,EAAE;;AAEvD;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,SAAO;EACP,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".page { max-width: 1600px; }\n\n.header {\n  margin-bottom: 2rem;\n}\n\n.title { font-size: 1.4rem; color: var(--black); margin-bottom: 0.2rem; font-weight: 700; }\n.subtitle { font-size: 0.8rem; color: var(--gray-500); }\n\n.loading {\n  padding: 2rem;\n  text-align: center;\n  color: var(--gray-500);\n  font-size: 0.85rem;\n}\n\n.emptyState {\n  background: white;\n  border: 2px dashed var(--border);\n  border-radius: var(--radius-lg);\n  padding: 3rem 2rem;\n  text-align: center;\n}\n\n.emptyIcon {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n}\n\n.emptyTitle {\n  font-size: 1.1rem;\n  color: var(--gray-900);\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.emptyText {\n  font-size: 0.85rem;\n  color: var(--gray-600);\n}\n\n/* Card List Layout */\n.cardsList {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.5rem;\n}\n\n.violationCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  transition: all 0.25s ease;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n}\n\n.violationCard:hover {\n  border-color: var(--gray-400);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.cardHeader {\n  padding: 0.5rem;\n  border-bottom: 1px solid var(--gray-50);\n  background: var(--gray-50);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.candidateInfo {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.candidateAvatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--green-light);\n  color: var(--green);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 0.65rem;\n  flex-shrink: 0;\n}\n\n.candidateDetails {\n  min-width: 0;\n  flex: 1;\n}\n\n.candidateName {\n  font-weight: 600;\n  color: var(--gray-900);\n  font-size: 0.75rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.candidateEmail {\n  font-size: 0.6rem;\n  color: var(--gray-500);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.statusBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.badgeIcon {\n  font-size: 0.8rem;\n}\n\n.statusgreen {\n  background: #d1fae5;\n  color: #047857;\n}\n\n.statusorange {\n  background: #fed7aa;\n  color: #b45309;\n}\n\n.statusred {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.statusdarkred {\n  background: #fecaca;\n  color: #7f1d1d;\n}\n\n/* Card Body */\n.cardBody {\n  padding: 0.5rem;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.5rem;\n  flex: 1;\n  border-bottom: 1px solid var(--gray-50);\n}\n\n.metricItem {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.metricLabel {\n  font-size: 0.6rem;\n  text-transform: capitalize;\n  letter-spacing: 0.04em;\n  color: var(--gray-500);\n  font-weight: 600;\n}\n\n.metricValue {\n  font-size: 0.7rem;\n  color: var(--gray-900);\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n.metricValueHighlight {\n  font-size: 0.95rem;\n  color: var(--red);\n  font-weight: 700;\n}\n\n/* Card Footer */\n.cardFooter {\n  padding: 0.4rem 0.5rem;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.viewBtn {\n  padding: 0.35rem 0.6rem;\n  background: var(--green);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.65rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.viewBtn:hover {\n  background: var(--green-mid);\n  transform: translateX(2px);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .cardsList {\n    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .cardsList {\n    grid-template-columns: 1fr;\n  }\n\n  .cardBody {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.85rem;\n  }\n\n  .metricItem:nth-child(3) {\n    grid-column: 1 / -1;\n  }\n\n  .cardHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .statusBadge {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .cardsList {\n    gap: 0.75rem;\n  }\n\n  .cardHeader {\n    padding: 0.85rem;\n  }\n\n  .cardBody {\n    padding: 0.85rem;\n  }\n\n  .cardFooter {\n    padding: 0.65rem 0.85rem;\n  }\n\n  .candidateName {\n    font-size: 0.85rem;\n  }\n\n  .candidateEmail {\n    font-size: 0.7rem;\n  }\n\n  .metricValue {\n    font-size: 0.8rem;\n  }\n\n  .metricValueHighlight {\n    font-size: 1rem;\n  }\n\n  .viewBtn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminProctoringViolations_page__wXCVM`,
	"header": `AdminProctoringViolations_header__1J-F6`,
	"title": `AdminProctoringViolations_title__bsAmN`,
	"subtitle": `AdminProctoringViolations_subtitle__nFq-c`,
	"loading": `AdminProctoringViolations_loading__Fy1NV`,
	"emptyState": `AdminProctoringViolations_emptyState__i2W09`,
	"emptyIcon": `AdminProctoringViolations_emptyIcon__JmPqg`,
	"emptyTitle": `AdminProctoringViolations_emptyTitle__aYiQV`,
	"emptyText": `AdminProctoringViolations_emptyText__CbZvD`,
	"cardsList": `AdminProctoringViolations_cardsList__ckYN-`,
	"violationCard": `AdminProctoringViolations_violationCard__a6mha`,
	"cardHeader": `AdminProctoringViolations_cardHeader__6mLKy`,
	"candidateInfo": `AdminProctoringViolations_candidateInfo__HMRt7`,
	"candidateAvatar": `AdminProctoringViolations_candidateAvatar__yeo+t`,
	"candidateDetails": `AdminProctoringViolations_candidateDetails__ayz7j`,
	"candidateName": `AdminProctoringViolations_candidateName__hGfVG`,
	"candidateEmail": `AdminProctoringViolations_candidateEmail__ICGZ-`,
	"statusBadge": `AdminProctoringViolations_statusBadge__3p79U`,
	"badgeIcon": `AdminProctoringViolations_badgeIcon__POqcq`,
	"statusgreen": `AdminProctoringViolations_statusgreen__d-UTa`,
	"statusorange": `AdminProctoringViolations_statusorange__Vq2Qu`,
	"statusred": `AdminProctoringViolations_statusred__TESFR`,
	"statusdarkred": `AdminProctoringViolations_statusdarkred__YlRAq`,
	"cardBody": `AdminProctoringViolations_cardBody__udtIs`,
	"metricItem": `AdminProctoringViolations_metricItem__SxV+Z`,
	"metricLabel": `AdminProctoringViolations_metricLabel__+lqCP`,
	"metricValue": `AdminProctoringViolations_metricValue__PRwJ0`,
	"metricValueHighlight": `AdminProctoringViolations_metricValueHighlight__CvvE7`,
	"cardFooter": `AdminProctoringViolations_cardFooter__F65ky`,
	"viewBtn": `AdminProctoringViolations_viewBtn__tATqc`
};
export default ___CSS_LOADER_EXPORT___;
